module.exports = __webpack_public_path__ + "static/media/calendar.16147785.svg";